const namespaced = true

const state = {
  searchQuery: '',
  isResult: true,
  delay: null,
  searchResult: [],
  loading: false,
}

const getters = {
  searchQuery: state => state.searchQuery,
  searchResult: state => state.searchResult,
  loading: state => state.loading,
}

const mutations = {
  setSearchQuery: (state, payload) => {
    state.searchQuery = payload
  },
  setSearchResult: (state, payload) => {
    state.searchResult = payload
  },
  removeSearchQuery: state => {
    state.searchQuery = ''
  },
  removeSearchResult: state => {
    state.searchResult = []
  },
  setDelay: (state, payload) => {
    state.delay = payload
  },
  loading: state => {
    state.loading = true
  },
  loaded: state => {
    state.loading = false
  },
}

const actions = {
  setSearchQuery: ({ state, commit, dispatch }, payload) => {
    commit('setSearchQuery', payload)
    dispatch('search')
  },
  search: ({ state, commit }) => {
    if (state.delay) {
      clearInterval(state.delay)
    }
    if (state.searchQuery.length >= 2) {
      commit(
        'setDelay',
        setTimeout(() => {
          commit('loading')
          axios.post('/api/search/', {
            search_query: state.searchQuery.toLocaleLowerCase(),
          }).then(({ data }) => {
            commit('setSearchResult', data.data)
          }).finally(() => commit('loaded'))
        }, 500),
      )
    } else {
      commit('removeSearchResult')
    }
  },
}

export default {
  getters,
  state,
  mutations,
  actions,
  namespaced,
}
